require('../../core/require');
require('./page.css');

window.addEventListener('pageshow', () => {
  if (window.location.hash === '#raccordement') {
    const retry = setInterval(() => {
      const projets = document.querySelector('#raccordement');
      if (projets && document.getElementsByTagName('main')[0].className !== 'hidden') {
        clearInterval(retry);
        projets.scrollIntoView();
      }
    }, 300);
  }
});
